import React from "react";
import { useEnsuredUser, useUserContext } from "../../common/contexts";
import { useGet, usePost } from "../../common/hooks";
import { Button, Checkbox, Divider, Form, Input, message } from "antd";
import _ from "lodash";
import { GoalieContactInfo, User } from "../../common/interfaces";
import Spinner from "../../common/components/Spinner";

export function Contact() {
  const user = useEnsuredUser();
  const { setUser } = useUserContext();
  const [form] = Form.useForm();

  const prefs = useGet<GoalieContactInfo | null>(
    `/api/goalieContactInfo?goalieId=${user.goalieId}`
  );
  const getUserInfo = usePost({ uri: "/api/user" });
  const postReq = usePost({
    uri: "/api/updateGoalieContactInfo",
    deps: [prefs]
  });

  const contactMethods = [
    { label: "Text", value: 0 },
    { label: "Email", value: 1 }
  ];

  if (prefs.data === undefined) {
    return <Spinner size={"large"} />;
  }

  const getInitPref = (key: string) => _.get(prefs.data, key);

  const arrayValidator = (rule: any, value: number[] | undefined) => {
    if (value === undefined || value.length === 0) {
      return Promise.reject(new Error("Must select at least one option."));
    }
    return Promise.resolve();
  };

  const onSubmit = () => {
    form.validateFields().then((values: GoalieContactInfo) => {
      postReq.send(
        { ...values, goalieId: user.goalieId },
        () => {
          getUserInfo.send({}, (data: User) => setUser(data));
          message.success("Contact information updated.");
        }
      );
    });
  };

  return (
    <>
      <Divider>Contact Information</Divider>
      <Form
        onFinish={onSubmit}
        layout={"vertical"}
        form={form}
        style={{ maxWidth: "500px" }}
      >
        <Form.Item
          label={"First Name"}
          name={"firstName"}
          rules={[{ required: true, message: "First name is required." }]}
          initialValue={getInitPref("firstName")}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Last Name"}
          name={"lastName"}
          rules={[{ required: true, message: "Last name is required." }]}
          initialValue={getInitPref("lastName")}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Email"}
          name={"email"}
          rules={[{ required: true, message: "Email is required." }]}
          initialValue={getInitPref("email")}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Phone Number"}
          name={"phoneNumber"}
          rules={[{ required: true, message: "Phone number is required." }]}
          initialValue={getInitPref("phoneNumber")}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Preferred Contact Methods"}
          name={"contactMethods"}
          rules={[{ validator: arrayValidator }]}
          initialValue={getInitPref("contactMethods")}
        >
          <Checkbox.Group options={contactMethods} />
        </Form.Item>
        <Form.Item>
          <Button type={"primary"} loading={postReq.isLoading} htmlType={"submit"}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
